import React,{useState} from "react";
import { useHistory } from "react-router-dom";
import {motion} from "framer-motion";
import {useSelector,useDispatch} from 'react-redux'
import {setIntro} from '../actions'
import GeneralModal from './GeneralModal'
import {sampleIntro} from '../ExData'

const contVariant={
  hidden:{
    x:"100vw"
  },
  visible:{
    x:0,
    transition:{
      delay:0.1,
      type:"spring",
      stiffness:80,
      mass:0.4,
      damping:8
    }
  }
}
const linkVariant={
  hover:{
    textShadow: "2px 2px 10px rgba(0,0,0,0.8)",
    boxShadow:"2px 2px 10px rgba(0,0,0,0.8)",
    transition:{
      duration:0.2
    }
  }
}
export default function Intro() {
  const {name,intro}=useSelector(states=>states.resumeData)
  const dispatch=useDispatch()
  const history = useHistory();
  const [introData,setIntroData]=useState(intro)
  const exIntros=sampleIntro
  function handleSubmit(e) {
    e.preventDefault();
    dispatch(setIntro(introData))
    history.push("/additional-details");
  }
  const [showModal,setShowModal]=useState(false)
  return (
    <>
    <GeneralModal showModal={showModal} setShowModal={setShowModal}>
        <h4 className="mt-4 text-primary"><strong>Sample Intro's</strong></h4>
        <p>you can refer the following introduction samples</p>
        <div className="sample-intro">
        {exIntros.map((intro,index)=>(
          <div>
          <strong>{intro.field}</strong>
          <div key={index} className="sample-box">
            {intro.content}
          </div>    
          </div>      
        ))}
        </div>
        <small>simply copy your desired content edit it and paste in textarea.</small>
    </GeneralModal>
    <motion.div className="container" exit={{x:"-100vw"}}>
      <motion.div className="form"
        variants={contVariant}
        initial="hidden"
        animate="visible"
      >
        <div><h1>{name}, want to add an intro?</h1>
        <button className="text-light my-2 py-2 b-1 random-btn" onClick={()=>setShowModal(true)}>refer sample intro's</button></div>
        <form onSubmit={handleSubmit}>
          <textarea rows="5" value={introData} onChange={(e)=>setIntroData(e.target.value)} placeholder="write about yourself"></textarea>
          <motion.button variants={linkVariant} whileHover="hover" type="submit">next</motion.button>
        </form>
      </motion.div>
    </motion.div>
    </>
  );
}
